module.exports = __webpack_public_path__ + "static/media/HKGroteskPro-Bold.9bae5afb.woff";